import { computed, Directive, effect, inject, TemplateRef, ViewContainerRef } from '@angular/core';
import { injectBrnComboboxBase } from './brn-combobox.token';

@Directive({
	selector: '[brnComboboxValueTemplate]',
})
export class BrnComboboxValueTemplate<T> {
	private readonly _templateRef = inject(TemplateRef);
	private readonly _viewContainerRef = inject(ViewContainerRef);

	private readonly _combobox = injectBrnComboboxBase<T>();

	protected readonly _value = computed<T | null>(() => {
		const value = this._combobox.value();

		if (value === null || value === undefined) {
			return null;
		}

		return value as T;
	});

	constructor() {
		effect(() => {
			const value = this._value();
			if (value !== null) {
				this._viewContainerRef.clear();
				this._viewContainerRef.createEmbeddedView(this._templateRef, {
					$implicit: value,
				});
			} else {
				this._viewContainerRef.clear();
			}
		});
	}
}
